export default "__VITE_PUBLIC_ASSET__09f67818__"